export default "__VITE_ASSET__fzx8$u3c__"